export default "__VITE_ASSET__B$RLiaBf__"